import { createRestash, applyMiddleware, logger } from 'restash';
import { IStore } from '../types';

const initialState: IStore = {
  isAuthenticated: false,
  user: null,
  token: null,
  refreshToken: null,
};

const middleware = applyMiddleware(logger());

const { Provider, Consumer, useStore } = createRestash({
  middleware,
  initialState,
  persistent: 'limbic-clinic-admin',
});

export {
  Provider,
  Consumer,
  useStore,
};
